<template>
  <div class="ele-body">
    <el-card shadow="never">
      <!-- 搜索表单 -->
      <el-form :model="table.where" label-width="77px" class="ele-form-search" @keyup.enter.native="$refs.table.reload()" @submit.native.prevent>
        <el-row :gutter="15">
          <el-col :md="4" :sm="12">
            <el-form-item label="手机号:">
              <el-input v-model.trim="table.where.mobile" maxlength="11" placeholder="请输入手机号" clearable />
            </el-form-item>
          </el-col>
          <el-col :md="4" :sm="12">
            <el-form-item label="姓名:">
              <el-input v-model.trim="table.where.teacherName" placeholder="请输入姓名" clearable />
            </el-form-item>
          </el-col>
          <el-col :md="4" :sm="12">
            <el-form-item label="卡号:">
              <el-input v-model.trim="table.where.cardNum" placeholder="请输入卡号" clearable />
            </el-form-item>
          </el-col>
          <el-col :md="4" :sm="12">
            <el-form-item label="角色:">
              <el-select v-model="table.where.roleId" placeholder="请选择角色" class="ele-block" clearable>
                <el-option v-for="(item, index) in roleList" :key="index" :label="item.roleName" :value="item.id" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :md="4" :sm="12">
            <el-form-item label="部门:">
              <el-select v-model="table.where.departmentId" placeholder="请选择部门" class="ele-block" clearable>
                <el-option v-for="(item, index) in departmentList" :key="index" :label="item.departmentName" :value="item.id" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :md="4" :sm="12">
            <div class="ele-form-actions">
              <el-button type="primary" @click="$refs.table.reload()" icon="el-icon-search" class="ele-btn-icon">查询 </el-button>
              <el-button @click="(table.where = {}) && $refs.table.reload()">重置</el-button>
            </div>
          </el-col>
        </el-row>
      </el-form>
      <!-- 操作按钮 -->
      <div class="ele-table-tool ele-table-tool-default">
        <el-button @click="add" type="primary" icon="el-icon-plus" class="ele-btn-icon" size="small">添加 </el-button>
        <el-button @click="remove()" type="danger" icon="el-icon-delete" class="ele-btn-icon" size="small">删除 </el-button>
        <el-button @click="sendMessage" type="primary" icon="el-icon-s-promotion" class="ele-btn-icon" size="small">发送账号短信 </el-button>
      </div>
      <!-- 数据表格 -->
      <ele-data-table ref="table" :config="table" :row-key="getRowKey" :choose.sync="choose" highlight-current-row>
        <template #default="{ index }">
          <el-table-column type="selection" width="45" align="center" fixed="left" :reserve-selection="true" />
          <el-table-column type="index" :index="index" width="45" align="center" fixed="left" show-overflow-tooltip />
          <el-table-column prop="name" label="姓名" sortable="custom" show-overflow-tooltip min-width="110" />
          <el-table-column prop="mobile" label="手机号" sortable="custom" show-overflow-tooltip min-width="110">
            <template #default="{ row }">{{ row.mobile | phoneSafe }}</template>
          </el-table-column>
          <el-table-column label="角色" show-overflow-tooltip min-width="110">
            <template #default="{ row }">
              <el-tag v-for="item in row.roles" :key="item.roleId" type="primary" size="mini">{{ item.role_name }}</el-tag>
            </template>
          </el-table-column>
          <!--          <el-table-column prop="state" label="状态" width="75px">-->
          <!--            <template slot-scope="{row}">-->
          <!--              <el-switch v-model="row.state" @change="editState(row)" :active-value="'1'" :inactive-value="'2'"/>-->
          <!--            {{row.state == 1 ? '接收': row.state == 2 ? '不接收' : ''}}-->
          <!--            </template>-->
          <!--          </el-table-column>-->
          <el-table-column label="操作" width="130px" align="center" :resizable="false">
            <template #default="{ row }">
              <el-link @click="edit(row)" icon="el-icon-edit" type="primary" :underline="false">修改</el-link>
              <el-popconfirm title="确定要删除此教师吗？" @onConfirm="remove(row)" class="ele-action">
                <el-link slot="reference" icon="el-icon-delete" type="danger" :underline="false">删除</el-link>
              </el-popconfirm>
            </template>
          </el-table-column>
        </template>
      </ele-data-table>
    </el-card>
    <!-- 编辑弹窗 -->
    <el-dialog
      :title="editForm.id ? '修改教师' : '添加教师'"
      :visible.sync="showEdit"
      width="650px"
      @closed="editForm = {}"
      :destroy-on-close="true"
      custom-class="ele-dialog-form"
      :lock-scroll="false"
    >
      <el-form :model="editForm" ref="editForm" :rules="editRules" label-width="85px">
        <el-row :gutter="15">
          <el-col :sm="12">
            <el-form-item label="所属部门:" prop="departmentId">
              <treeselect
                v-model="editForm.departmentId"
                :options="deptList"
                :multiple="true"
                :flat="true"
                placeholder="请选择所属部门"
                :defaultExpandLevel="4"
                :normalizer="
                  (d) => {
                    return { id: d.id, label: d.departmentName };
                  }
                "
                style="line-height: 20px"
              />
            </el-form-item>
            <el-form-item label="用户名:" prop="name">
              <el-input v-model="editForm.name" placeholder="请输入用户名" clearable />
            </el-form-item>
            <el-form-item v-show="editForm.id" label="是否本地:" prop="netLocal">
              <el-select v-model="editForm.netLocal" placeholder="是否本地号码" class="ele-block" clearable>
                <el-option label="是" :value="'1'" />
                <el-option label="否" :value="'0'" />
              </el-select>
            </el-form-item>
            <el-form-item label="照片上传:" prop="avatar">
              <el-upload
                ref="uploadHead"
                :show-file-list="false"
                :action="$http.defaults.baseURL + '/file/getFilePath'"
                :headers="$http.defaults.headers.common"
                name="multipartFile"
                :data="{ path: 'teacherImg/' }"
                multiple
                :limit="1"
                :on-change="handlePictureCardPreview"
                :on-success="uploadSuccess"
                accept="image/png,image/jpg,image/jpeg"
              >
                <el-image v-if="imgSrc" :src="imgSrc" alt="" style="width: 200px" />
                <el-button v-show="!editForm.avatar" size="small" type="primary">点击上传</el-button>
                <div v-show="!editForm.avatar" slot="tip" class="el-upload__tip">
                  只能上传jpg/png文件，且不超过500kb
                </div>
              </el-upload>
            </el-form-item>
          </el-col>
          <el-col :sm="12">
            <el-form-item label="角色:">
              <el-select v-model="editForm.roleId" placeholder="请选择角色" class="ele-block" clearable multiple>
                <el-option v-for="(item, index) in roleList" :key="index" :label="item.roleName" :value="item.id" />
              </el-select>
            </el-form-item>
            <el-form-item label="手机号:" prop="mobile">
              <el-input v-model="editForm.mobile" placeholder="请输入手机号" clearable />
            </el-form-item>
            <el-form-item label="卡号:">
              <el-input v-model="editForm.cardNum" maxlength="10" placeholder="请输入卡号" clearable />
            </el-form-item>
            <el-form-item label="网络类型:" prop="netType">
              <el-select v-model="editForm.netType" placeholder="网络类型" class="ele-block" clearable>
                <el-option label="移动" :value="'1'" />
                <el-option label="联通" :value="'2'" />
                <el-option label="电信" :value="'3'" />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer">
        <el-button @click="showEdit = false">取消</el-button>
        <el-button type="primary" @click="save(editForm.id)">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import Treeselect from '@riophae/vue-treeselect'; // 下拉树
  import '@riophae/vue-treeselect/dist/vue-treeselect.css';
  import {
    addSchoolTeacher,
    updateSchoolTeacher,
    delSchoolTeacher,
    batchDelSchoolTeacher,
    getAllDepartList,
    getSchoolRoleList,
    sendTeacherAccountMessage,
  } from '@/config/api';

  export default {
    name: 'TeacherList',
    components: { Treeselect },
    data() {
      return {
        table: {
          // 表格配置
          url: '/school/teacher/getSchoolTeacherList',
          where: {},
          parseData(res) {
            if (res.resCode == 200) res.code = 0;
            res.count = res.data.total;
            res.data = res.data.records;
            return res;
          },
        },
        choose: [], // 表格选中数据
        showEdit: false, // 是否显示表单弹窗
        editForm: {}, // 表单数据
        editRules: {
          // 表单验证规则
          name: [{ required: true, message: '请输入用户名', trigger: 'blur' }],
          mobile: [{ required: true, message: '请输入手机号', trigger: 'blur' }],
          // roleId: [{ required: true, message: '请选择角色', trigger: 'change' }],
          departmentId: [{ required: true, message: '请选择部门', trigger: 'change' }],
          netType: [{ required: true, message: '请选择运营商', trigger: 'change' }],
        },
        roleList: [], // 角色列表
        showImport: false, // 显示导入弹窗
        uploadLoading: false, // 导入加载状态
        deptList: [],
        imgSrc: '', //预览图片地址
        getRowKey(row) {
          return row.id;
        },
        departmentList: [],
      };
    },
    mounted() {
      this.queryRoles(); // 查询角色列表
      this.queryOrg(); //查询部门列表
    },
    methods: {
      // 显示添加
      add() {
        this.imgSrc = '';
        this.showEdit = true;
      },
      /* 显示编辑 */
      edit(row) {
        if (row.roles.length != 0) {
          if (row.roles[0].administrator == '1') return this.$message.error('不能更改初始管理员');
        }
        this.editForm = Object.assign({}, row, {
          roleId: row.roles.map((d) => d.id),
          departmentId: row.departments.map((d) => d.id),
        });
        this.imgSrc = this.editForm.avatar;
        this.showEdit = true;
      },
      /* 保存编辑 */
      save(userId) {
        this.$refs['editForm'].validate((valid) => {
          if (valid) {
            const loading = this.$loading({ lock: true });
            let formData = new FormData();
            for (let key in this.editForm) {
              if (this.editForm[key] !== null && this.editForm[key] !== undefined) {
                formData.append(key, this.editForm[key]);
              }
            }
            if (userId == undefined) {
              //添加教师
              addSchoolTeacher(formData)
                .then((res) => {
                  loading.close();
                  if (res.data.resCode == 200) {
                    this.showEdit = false;
                    this.$message({ type: 'success', message: res.data.resMsg });
                    this.$refs.table.reload();
                  } else {
                    this.$message.error(res.data.resMsg);
                  }
                })
                .catch((e) => {
                  loading.close();
                  this.$message.error(e.message);
                });
            } else {
              //编辑角色
              updateSchoolTeacher(formData).then((res) => {
                loading.close();
                if (res.data.resCode == 200) {
                  this.showEdit = false;
                  this.$message({ type: 'success', message: res.data.resMsg });
                  this.$refs.table.reload();
                } else {
                  this.$message.error(res.data.resMsg);
                }
              });
            }
          } else {
            return false;
          }
        });
      },
      /* 删除 */
      remove(row) {
        if (!row) {
          // 批量删除
          if (this.choose.length === 0) return this.$message.error('请至少选择一条数据');
          for (let i = 0; i < this.choose.length; i++) {
            if (this.choose[i].roles.length > 0) {
              if (this.choose[i].roles[0].administrator == '1') {
                return this.$message.error('不能删除初始管理员');
              }
            }
          }
          let ids = this.choose.map((d) => d.id);
          this.$confirm('确定要删除选中的用户吗?', '提示', { type: 'warning' })
            .then(() => {
              const loading = this.$loading({ lock: true });
              let formData = new FormData();
              formData.append('teacherIds', ids);
              batchDelSchoolTeacher(formData)
                .then((res) => {
                  loading.close();
                  if (res.data.resCode == 200) {
                    this.$message({ type: 'success', message: res.data.resMsg });
                    this.$refs.table.reload();
                  } else {
                    this.$refs.table.reload();
                    // this.$message.error(res.data.resMsg);
                  }
                })
                .catch(() => {
                  loading.close();
                  this.$refs.table.reload();
                  // this.$message.error(e.message);
                });
            })
            .catch(() => 0);
        } else {
          // 单个删除
          if (row.roles.length > 0 && row.roles[0].administrator == '1') return this.$message.error('不能删除初始管理员');
          const loading = this.$loading({ lock: true });
          let formData = new FormData();
          formData.append('teacherId', row.id);
          // formData.append("state", -1);
          delSchoolTeacher(formData)
            .then((res) => {
              loading.close();
              if (res.data.resCode == 200) {
                this.$message({ type: 'success', message: res.data.resMsg });
                this.$refs.table.reload();
              } else {
                this.$message.error(res.data.resMsg);
              }
            })
            .catch((e) => {
              loading.close();
              this.$message.error(e.message);
            });
        }
      },
      /* 更改状态 */
      // editState(row) {
      //   if(row.roles[0].administrator == '1') {
      //     this.$refs.table.reload();
      //     return this.$message.error('不能更改除初始管理员');
      //   }
      //   const loading = this.$loading({lock: true});
      //   let formData = new FormData();
      //   formData.append("id", row.id);
      //   formData.append("state", row.state);
      //   delSchoolTeacher(formData).then((res) => {
      //     loading.close();
      //     if (res.data.resCode == 200) {
      //       this.$message({type: 'success', message: res.data.resMsg});
      //       this.$refs.table.reload();
      //     } else {
      //       row.state = !row.state ? 1 : 2;
      //       this.$message.error(res.data.resMsg);
      //     }
      //   })
      // },
      /* 查询角色列表 */
      queryRoles() {
        getSchoolRoleList()
          .then((res) => {
            if (res.data.resCode == 200) {
              this.roleList = res.data.data;
            } else {
              this.$message.error(res.data.resMsg);
            }
          })
          .catch((e) => {
            this.$message.error(e.message);
          });
      },
      /* 查询部门列表 */
      queryOrg() {
        getAllDepartList()
          .then((res) => {
            if (res.data.resCode == 200) {
              this.departmentList = res.data.data;
              this.deptList = this.$util.toTreeData(res.data.data, 'id', 'parentId');
            } else {
              this.$message.error(res.data.resMsg);
            }
          })
          .catch((e) => {
            this.$message.error(e.message);
          });
      },
      //照片上传限制
      handlePictureCardPreview(file) {
        const fileSize = file.size / 1024 / 1024 < 0.5;
        const extension = file.name.substring(file.name.lastIndexOf('.') + 1) === 'png';
        const extension2 = file.name.substring(file.name.lastIndexOf('.') + 1) === 'jpg';
        if (!extension && !extension2) {
          this.$message.error('只能上传png、jpg格式的图片');
          return false;
        }
        if (!fileSize) {
          this.$message.error('图片大小不能超过500K');
          return false;
        }
        this.imgSrc = URL.createObjectURL(file.raw);
      },
      //照片上传成功
      uploadSuccess(res) {
        if (res.resCode == 200) {
          this.editForm.avatar = res.data[0].fileUrl;
        }
      },
      //发送账号短信
      sendMessage() {
        if (this.choose.length === 0) return this.$message.error('请至少选择一个老师');
        let formData = new FormData();
        let teacherIds = this.choose.map((d) => d.id);
        formData.append('teacherIds', teacherIds);
        sendTeacherAccountMessage(formData).then((res) => {
          if (res.data.resCode == 200) {
            this.$message({ type: 'success', message: '已发送账号短信' });
            this.$refs.table.reload();
            this.$refs.table.clearSelection();
          } else {
            this.$message.error(res.data.resMsg);
            this.$refs.table.reload();
            this.$refs.table.clearSelection();
          }
        });
      },
    },
  };
</script>

<style scoped>
  .ele-block >>> .el-upload,
  .ele-block >>> .el-upload-dragger {
    width: 100%;
  }
  .org-tree-group {
    border: 1px solid hsla(0, 0%, 60%, 0.15);
    /*height: calc(100vh - 262px);*/
    height: 55vh;
    box-sizing: border-box;
    overflow-x: auto;
  }

  .org-tree-group >>> .el-tree-node__content {
    height: 40px;
  }

  .org-tree-group >>> .el-tree-node__content > .el-tree-node__expand-icon {
    margin-left: 10px;
  }
</style>
